import {
  CHECKUP_DOCUMENT_REQUEST,
  CHECKUP_DOCUMENT_SUCCESS,
  CHECKUP_DOCUMENT_ERROR,
  DOCUMENTS_SUCCESS,
  DOCUMENTS_ERROR,
  DOCUMENTS_REQUEST,
  SEND_DOCUMENTS_REQUEST,
  SEND_DOCUMENTS_SUCCESS,
  SEND_DOCUMENTS_ERROR,
  SEND_CHECKUP_DOCUMENTS_REQUEST,
  SEND_CHECKUP_DOCUMENTS_SUCCESS,
  SEND_CHECKUP_DOCUMENTS_ERROR,
  CUSTOMER_DOCUMENTS_REQUEST,
  CUSTOMER_DOCUMENTS_SUCCESS,
  CUSTOMER_DOCUMENTS_ERROR,
  CUSTOMER_DOCUMENT_PREVIEW_REQUEST,
  CUSTOMER_DOCUMENT_PREVIEW_SUCCESS,
  CUSTOMER_DOCUMENT_PREVIEW_ERROR,
  CUSTOMER_DOCUMENT_PREVIEW_CLEAR,
} from "./constants"
import { CustomerDocument, DocumentType } from "client/documents/types"
import { Action, ActionWithoutPayload, Message } from "types/redux"

export const actions = {
  success: (response: string): Action<string> => {
    return {
      type: DOCUMENTS_SUCCESS,
      payload: response,
    }
  },
  error: (error: string): Action<Message> => {
    return {
      type: DOCUMENTS_ERROR,
      payload: { type: "error", text: error || "Error document" },
    }
  },

  // Request(callid, documentsType) if documentsType = undefined, get * available documents by default
  request: (
    callId: string | number,
    documentsType?: DocumentType[],
  ): Action<{ documentsType?: DocumentType[]; callId: string | number }> => ({
    type: DOCUMENTS_REQUEST,
    payload: { documentsType, callId },
  }),

  requestDocument: (
    consultationType: "calls" | "teleexpertises" | "consultations",
    callId: string | number,
    documentsType?: DocumentType[],
  ): Action<{
    documentsType?: DocumentType[]
    consultationType: "calls" | "teleexpertises" | "consultations"
    callId: string | number
  }> => ({
    type: DOCUMENTS_REQUEST,
    payload: { documentsType, consultationType, callId },
  }),
  requestCheckupDocument: (payload: {
    relative_id: number | null
    vitals: Record<string, unknown>
  }): Action<{
    relative_id: number | null
    vitals: Record<string, unknown>
  }> => ({
    type: CHECKUP_DOCUMENT_REQUEST,
    payload,
  }),
  checkupDocumentSuccess: (documentUrl: string): Action<string> => ({
    type: CHECKUP_DOCUMENT_SUCCESS,
    payload: documentUrl,
  }),
  checkupDocumentError: (error: string): Action<Message> => ({
    type: CHECKUP_DOCUMENT_ERROR,
    payload: { type: "error", text: error || "Error document" },
  }),
  sendDocumentsRequest: (payload: { id: number }): Action<{ id: number }> => ({
    type: SEND_DOCUMENTS_REQUEST,
    payload,
  }),
  sendDocumentsSuccess: (s: string): Action<Message> => ({
    type: SEND_DOCUMENTS_SUCCESS,
    payload: { type: "success", text: s },
  }),

  sendDocumentsError: (e: string): Action<Message> => ({
    type: SEND_DOCUMENTS_ERROR,
    payload: { type: "error", text: e },
  }),
  sendCheckupDocumentsRequest: (payload: { relativeId: number | null }): Action<{ relativeId: number | null }> => ({
    type: SEND_CHECKUP_DOCUMENTS_REQUEST,
    payload,
  }),
  sendCheckupDocumentsSuccess: (s: string): Action<Message> => ({
    type: SEND_CHECKUP_DOCUMENTS_SUCCESS,
    payload: { type: "success", text: s },
  }),
  sendCheckupDocumentsError: (e: string): Action<Message> => ({
    type: SEND_CHECKUP_DOCUMENTS_ERROR,
    payload: { type: "error", text: e },
  }),

  // Documents imported by the patient (Profile > Documents importés)
  customerDocumentsRequest: (): ActionWithoutPayload => ({
    type: CUSTOMER_DOCUMENTS_REQUEST,
  }),
  customerDocumentsSuccess: (
    documents: CustomerDocument[],
  ): Action<CustomerDocument[]> => ({
    type: CUSTOMER_DOCUMENTS_SUCCESS,
    payload: documents,
  }),
  customerDocumentsError: (e: string): Action<Message> => ({
    type: CUSTOMER_DOCUMENTS_ERROR,
    payload: { type: "error", text: e },
  }),
  customerDocumentPreviewRequest: (
    document: CustomerDocument,
  ): Action<CustomerDocument> => ({
    type: CUSTOMER_DOCUMENT_PREVIEW_REQUEST,
    payload: document,
  }),
  customerDocumentPreviewSuccess: (url: string): Action<string> => ({
    type: CUSTOMER_DOCUMENT_PREVIEW_SUCCESS,
    payload: url,
  }),
  customerDocumentPreviewError: (e: string): Action<Message> => ({
    type: CUSTOMER_DOCUMENT_PREVIEW_ERROR,
    payload: { type: "error", text: e },
  }),
  customerDocumentPreviewClear: (): ActionWithoutPayload => ({
    type: CUSTOMER_DOCUMENT_PREVIEW_CLEAR,
  }),
}
